/**
 * HAWK PRODUCT LOGIC vFinal (Data-Driven Price Engine)
 * - Fiyat hesaplaması DOM'dan (ekrandan) bağımsız hale getirildi.
 * - Mobilde fiyat listesi gizli olsa bile doğru hesaplama yapar.
 * - 'Onayla' denildiğinde 0 TL olma sorununu çözer.
 */

class HawkProductLogic {
    constructor() {
        this.proxyUrl = 'https://api.hawkgaming.com.tr/api/proxy';
        this.categories = { 'Future': [], 'Fab': [], 'Fame': [], 'Pro': [], 'Aksesuar': [] };
        this.isInitialized = false;
        this.currentCategory = "future";
        this.lastClickedItemId = null;
        
        window.desteklenenDesenler = {};
        window.orjfiyatlar = [];
        window.customfiyatlar = [];
        
    }

    async init(approved) {
        if (this.isInitialized) return;
        try {
            await this.fetchCustomPrices();
            const data = await this.fetchProducts(approved);
            
            if(data && data.items) {
                this.categorizeItems(data.items);
                this.renderAllTabs();
                this.bindCategoryButtons();
                setTimeout(() => { this.handleInitialLoad(); }, 500);
                this.isInitialized = true;
            }
        } catch (error) {
            const loading = document.getElementById("loadingson");
            if(loading) loading.style.display = "none";
        }
    }

    // --- API ---
    async fetchProducts(approved) {
        try {
            const response = await fetch(this.proxyUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ endpoint: '/product/all', body: { id: 0, Sorting: "", CurrentPage: 1, Approved: approved, RowCount: 50 } })
            });
            return await response.json();
        } catch (e) { return null; }
    }

    async fetchCustomPrices() {
        try {
            const response = await fetch(this.proxyUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ endpoint: '/common/definedetails', body: { id: 0, Sorting: "", CurrentPage: 1, CatID: 8, RowCount: 50 } })
            });
            const res = await response.json();
            window.customfiyatlar = res.items || [];
        } catch (e) {  }
    }

    categorizeItems(items) {
        this.categories.Future = items.filter(i => i.Category === 'Future');
        this.categories.Fab = items.filter(i => i.Category === 'Fab');
        this.categories.Fame = items.filter(i => i.Category === 'Fame');
        this.categories.Pro = items.filter(i => i.Category === 'Pro');
        this.categories.Aksesuar = items.filter(i => i.Category === 'Aksesuar');
        
        window.hawk_data2 = { items: items };
        window.futureItems = this.categories.Future;
        window.fabItems = this.categories.Fab;
        window.fameItems = this.categories.Fame;
        window.proItems = this.categories.Pro;
        window.aksesuarItems = this.categories.Aksesuar;
    }

    // --- UI RENDER ---
    renderAllTabs() {
        this.renderTab(this.categories.Future, 'tab2', 'future');
        this.renderTab(this.categories.Fab, 'tab1', 'fab');
        this.renderTab(this.categories.Fame, 'tab4', 'fame');
        this.renderTab(this.categories.Pro, 'tab5', 'pro');
        this.renderTab(this.categories.Aksesuar, 'tab3', 'aksesuar');
    }

    // HawkProductLogic.js -> renderTab (SEO GÜÇLENDİRİLMİŞ)

    renderTab(items, containerId, folderName) {
        const container = document.getElementById(containerId);
        if (!container) return;
        container.innerHTML = '';
        
        items.forEach(item => {
            const div = document.createElement('div');
            div.className = 'hawkchair';
            div.id = item.id;
            
            // SEO Dostu Görsel İsmi
            let imgFolder = folderName;
            let imgName = item.Title;
            if(folderName === 'fab') imgName = item.Title.split(' ')[1];
            
            // --- SEO GELİŞTİRMESİ BAŞLANGICI ---
            // Google için anlamlı, uzun kuyruklu (Long-tail) açıklama
            // Örn: "Hawk Future Coal Kumaş Oyuncu Koltuğu - 3D Özelleştir"
            const materialType = (item.Category.includes("Pro") || [10, 32, 33].includes(item.id)) ? "Deri" : "Kumaş";
            const seoAltText = `Hawk Gaming Chair ${item.Title} ${materialType} Oyuncu Koltuğu 3D Tasarla`;
            
            div.innerHTML = `
                <span class="hawkchair-title">${item.Title}</span>
                <img class="hawkchair-image" 
                     src="/static/butonlar/${imgFolder}/${imgName}.webp" 
                     alt="${seoAltText}" 
                     title="${seoAltText} - Seçmek için tıklayın"
                     loading="lazy" 
                     width="100" height="100"
                     onerror="this.src='/static/image/placeholder.png'">
            `;
            // --- SEO GELİŞTİRMESİ BİTİŞİ ---

            div.addEventListener('click', () => this.handleItemClick(item, div));
            container.appendChild(div);
        });
    }

    bindCategoryButtons() {
        const buttons = [
            { id: 'futureklasor', cat: 'future', model: 'https://design.hawkchair.com/static/models/futureOrj2.glb', defaultId: '8' },
            { id: 'fabklasor', cat: 'fab', model: 'https://design.hawkchair.com/static/models/fabOrj2.glb', defaultId: '1' },
            { id: 'fameklasor', cat: 'fame', model: 'https://design.hawkchair.com/static/models/fameO6rj.glb', defaultId: '21' },
            { id: 'proklasor', cat: 'pro', model: 'https://design.hawkchair.com/static/models/proOrj2.glb', defaultId: '22' },
            { id: 'aksesuarklasor', cat: 'aksesuar', model: 'https://design.hawkchair.com/static/models/future-yastik3.glb', defaultId: '14' }
        ];
        buttons.forEach(btn => {
            const element = document.getElementById(btn.id);
            if (!element) return;
            element.addEventListener('click', (e) => {
                if (this.currentCategory === btn.cat) return;
                this.switchCategory(btn.cat, btn.model, btn.defaultId);
            });
        });
    }

    // HawkProductLogic.js -> switchCategory GÜNCELLEMESİ

    switchCategory(categoryName, modelUrl, defaultId) {
        this.currentCategory = categoryName;
        window.cinsbutton = [categoryName]; // Global değişkeni güncelle

        // 1. Üst Butonları Güncelle (Aktiflik)
        document.querySelectorAll('.other-selection-button').forEach(b => b.classList.remove('active'));
        const activeBtn = document.getElementById(`${categoryName}klasor`);
        if(activeBtn) activeBtn.classList.add('active');

        // 2. İçerik Sekmelerini Yönet (Resetle ve Yeniden Aç)
        // Önce hepsini kapat
        document.querySelectorAll('.other-selection-content').forEach(pane => {
            pane.classList.remove('active', 'show');
            pane.style.display = 'none'; // Zorla gizle (CSS çakışmasını önler)
            pane.style.opacity = '0';
        });

        // Hedef sekmeyi aç
        const targetPane = document.getElementById(categoryName);
        if(targetPane) {
            targetPane.classList.add('active', 'show');
            targetPane.style.display = 'block'; // Zorla göster
            
            // Fade-in efekti için minik gecikme
            setTimeout(() => { targetPane.style.opacity = '1'; }, 10);
            
            // FAB ÖZEL DÜZELTMESİ:
            // Fab yapısında iç içe tablar (#tab1) olduğu için onu da manuel tetiklemeliyiz.
            if (categoryName === 'fab') {
                const innerTab = document.getElementById('tab1');
                if(innerTab) {
                    innerTab.classList.add('active', 'show');
                    innerTab.style.display = 'flex'; // Grid veya Flex yapısını koru
                    innerTab.style.opacity = '1';
                }
            }
        }

        // 3. İçeriği Render Et (Listeyi tazele)
        this.renderAllTabs(); 
        this.resetCategoryState();

        // 4. 3D Modeli Yükle
        if(window.hawk3D) {
            window.hawk3D.loadModel(modelUrl, () => {
                 if(window.hawkMaterials) window.hawkMaterials.captureInitialState();

                if (!window.isAutoURLSelection) {
                    setTimeout(() => {
                        const defaultItem = document.getElementById(defaultId);
                        if(defaultItem) defaultItem.click();
                    }, 100);
                }
            });
        }
    }

    // -------------------------------------------------------
    // KATEGORİ VE ÜRÜN DEĞİŞİMİNDE TAM TEMİZLİK
    // -------------------------------------------------------
    resetCategoryState() {
        // 1. Bayrakları Sıfırla (Data Temizliği)
        window.bellogoyuklendi = false; 
        window.arkalogoyuklendi = false; 
        window.onlogoyuklendi = false; 
        window.nicknameyuklendi = false; 
        window.yastiklogoyuklendi = false; 
        
        // 2. İsimleri ve Verileri Sıfırla
        window.tasarimismi = ["Orijinal"]; 
        window.tasarimismiKontrol = ["Orijinal"];
        window.resultonlogo = []; 
        window.resultarkalogo = []; 
        window.resultbellogo = []; 
        window.resultyastiklogo = [];

        // 3. UI TEMİZLİĞİ (KRİTİK EKLEME: X BUTONLARINI GİZLE)
        // Kategori/Ürün değiştiğinde tüm fiyat kutularını varsayılan hale getir.
        const uiIds = ['onfiyati', 'arkafiyati', 'belfiyati', 'isimfiyati'];
        
        uiIds.forEach(id => {
            

            const el = document.getElementById(id);
            if(el) {
                // X Butonunu Gizle
                const removeBtn = el.querySelector('.remove-button');
                if(removeBtn) removeBtn.style.display = 'none';
                
                // Kutuyu Normale Döndür (Siyah -> Beyaz)
                el.classList.remove('black');
                el.classList.add('active');
                
                // Görünürlük ayarı (updateButtonVisibility sonra çalışacak ama burası reset)
                el.style.display = 'flex'; 
                el.style.opacity = '1';
                el.style.pointerEvents = 'all';
            }
        });

        // 4. Inputları Temizle
        const nickInput = document.getElementById('nickname');
        if(nickInput) nickInput.value = "";
    }

    // HawkProductLogic.js -> handleItemClick GÜNCELLEMESİ (Deri/Kumaş Fix)

    handleItemClick(item, divElement) {
        // ... (Standart Seçim Kodları) ...
        if (this.lastClickedItemId === item.id) return;
        document.querySelectorAll('.hawkchair').forEach(btn => btn.classList.remove('selected'));
        divElement.classList.add('selected');
        this.lastClickedItemId = item.id;
        window.secilimodelindex = item.id;
        window.cinsbutton = [item.Category.toLowerCase()];
        window.tasarimismiKontrol = [item.Title];

        // Cache Temizliği
        if(window.hawkMaterials) window.hawkMaterials.originalTextures = {};

        // Hammadde
        let rawMaterial = "kumas";
        const leatherIDs = [10, 32, 33, 30, 31];
        if (leatherIDs.includes(item.id)) rawMaterial = "deri";
        window.hammadde = rawMaterial;

        // --- 1. TEMİZ (BAKESİZ) LİNKİ OLUŞTUR (BİZ YAPIYORUZ) ---
        const modelsMap = {
            8: "black", 9: "coal", 10: "dark", 11: "dream", 12: "gray", 13: "stone",
            22: "black", 27: "coal", 29: "gray", 28: "stone", 30: "dark", 31: "aura"
        };
        const colorCode = modelsMap[item.id];
        window.belCleanLink = null;     // Bizim oluşturduğumuz (Logosuz)
        window.belOriginalLink = null;  // API'den gelecek (Logolu)
        if (item.Category === "Future") {
            // Future için temiz kumaş (alt-yastikk.webp)
            window.belCleanLink = `https://design.hawkchair.com/static/yastiklar/${colorCode}/alt-yastikk.webp`;
        } 
        else if (item.Category === "Pro") {
            // Pro için temiz kumaş
            window.proCleanLink = `https://design.hawkchair.com/static/yastiklar/pro/${colorCode}/alt-yastikk.webp`;
            // İmza alanı sabittir
            window.probelcacheLink = "https://design.hawkchair.com/static/yastiklar/pro/image.png"; 
            window.probelYastikcacheLink = window.proCleanLink; // Eski değişken uyumluluğu
        }

        // --- DEBUG: Sadece Clean Linki Göster ---
        /* console.group(`🟡 MODEL: ${item.Title} (${colorCode})`);
        console.log(`   - Clean Path (Bizim): ${window.belCleanLink || window.proCleanLink}`);
        console.log(`   - Original Path (API): Henüz yok (renderPatterns'da alınacak)`);
        console.groupEnd(); */
        
        if(window.updateOrderJson) window.updateOrderJson(parseInt(item.id), "ProductID");
        
        this.loadSpecificModel(item);
        this.renderPatterns(item);
    }

     loadSpecificModel(item) {
        const viewer = window.hawk3D;
        if (!viewer) return;
        
        // Başlık kontrolü için güvenli string
        const t = item.Title.toLowerCase();
        let modelUrl = "";
        
        // Daha esnek kontroller (Include ile)
        if (t.includes("fab") && (t.includes("baş") || t.includes("üst"))) modelUrl = "https://design.hawkchair.com/static/models/fabBasyastikFinal.glb";
        else if (t.includes("future") && (t.includes("baş") || t.includes("üst"))) modelUrl = "https://design.hawkchair.com/static/models/futureBasyastikFinal.glb";
        else if (t.includes("fab") && t.includes("bel")) modelUrl = "https://design.hawkchair.com/static/models/fabBelyastikFinal2.glb";
        else if (t.includes("future") && t.includes("bel")) modelUrl = "https://design.hawkchair.com/static/models/futureBelyastikFinal2.glb";
        else if (t.includes("mouse")) modelUrl = "https://design.hawkchair.com/static/models/2mousepad.glb";
        else if (t.includes("shirt")) modelUrl = "https://design.hawkchair.com/static/models/6tshirt.glb";
        
        // Varsayılan olarak Future Koltuk (Güvenlik önlemi)
        // else modelUrl = "https://design.hawkchair.com/static/models/future28.glb";

        if (modelUrl) {
            viewer.loadModel(modelUrl, () => {
                if(window.hawkMaterials) {
                    window.hawkMaterials.captureInitialState();
                    // Aksesuarlarda Realism bazen gereksiz parlama yapabilir, duruma göre aç/kapa:
                    window.hawkMaterials.applyRealismMaps(); 
                }
            });
        }
    }

    renderPatterns(item) {
        const container = document.getElementById('patterns-container');
        if (!container) return;
        container.innerHTML = ''; 
        
        let lastClickedPatternId = null;
        let targetToClick = null;
        let hasOrijinal = false;

        // Loader AÇARKEN:
        const midLoader = document.getElementById('midLoader');
        const clickBlocker = document.getElementById('clickBlocker');
        const guard = document.getElementById('fullScreenGuard');

        if (!item.Patterns || item.Patterns.length === 0) return;

        // Fiyatları set et (İlk yükleme için)
        // Eğer logo yüklüyse setPrices bunu ezmez, updateTotalPrice doğruyu bulur.
        // this.setPrices(item, item.Patterns[0]); 
            window.currentPatternFeatures = item.Patterns[0].Features;
            this.setPrices(item, item.Patterns[0]);
        item.Patterns.forEach((pattern, index) => {
            // Hidden Areas (Aynı)
            const hiddenAreas = [];
            if (!pattern.canAddFrontLogo) hiddenAreas.push("ön");
            if (!pattern.canAddBackLogo) hiddenAreas.push("arka");
            if (!pattern.canAddWaistLogo) hiddenAreas.push("bel");
            if (!pattern.canAddSideLogo) { hiddenAreas.push("yastık"); hiddenAreas.push("nick"); }
            window.desteklenenDesenler[pattern.Title] = hiddenAreas;
            // Div oluştur
            const div = document.createElement('div');
            div.className = 'pattern-content';
            const parts = pattern.Title.split(' ');
            const divId = parts[parts.length - 1];
            div.id = divId;
            div.dataset.value = pattern.TextColor;
            div.dataset.patternId = pattern.PatternID;

            // Orijinal Link Yakalama (Aynı)
            if (pattern.Title.includes("Orijinal")) {
                let waistKey = "";
                if (item.Category === "Future") waistKey = "FUTURE alt-yastik";
                else if (item.Category === "Pro") waistKey = "PRO YASTIK";
                else if (item.Category === "Fab") waistKey = "FAB alt-yastik";

                if (waistKey) {
                    const waistFeature = pattern.Features.find(f => f.TypeName === waistKey);
                    if (waistFeature) {
                        if (item.Category === "Future") window.belOriginalLink = waistFeature.FilePath;
                        else if (item.Category === "Pro") window.proOriginalLink = waistFeature.FilePath;
                        /* console.log(`🔒 [${item.Category}] Orijinal Bel Linki Alındı: ${waistFeature.FilePath}`); */
                    }
                }
            }

            // İkon
            const icon = pattern.Features.find(f => f.TypeName === "icon");
            if (icon && icon.FilePath && icon.FilePath.length > 5) {
                const img = document.createElement('img');
                img.src = icon.FilePath;
                img.alt = pattern.Title;
                img.onerror = () => { img.style.display = 'none'; div.innerText = divId; }; 
                div.appendChild(img);
            } else { div.innerText = divId; }

            if (div.id === "Orijinal") { div.style.display = "none"; hasOrijinal = true; targetToClick = div; }

            // --- TIKLAMA EVENTİ (SIFIRLAMA YOK) ---
            // HawkProductLogic.js -> renderPatterns -> div.addEventListener

            div.addEventListener('click', async () => {
                if (lastClickedPatternId === div.id) return;
                
                // 1. KİLİDİ HEMEN AKTİF ET (Kullanıcı Tıkladığı An)
                // ----------------------------------------------------
                const midLoader = document.getElementById('midLoader');
                const clickBlocker = document.getElementById('clickBlocker');
                const guard = document.getElementById('fullScreenGuard'); // Varsa tam ekran koruyucu

                if (guard) guard.style.display = 'block';
                if (clickBlocker) {
                    clickBlocker.style.display = 'block';
                    clickBlocker.classList.add('active'); // CSS ile pointer-events: all yapar
                }
                if (midLoader) {
                    midLoader.style.display = 'block';
                    requestAnimationFrame(() => midLoader.classList.add('active'));
                }
                // ----------------------------------------------------

                try {
                    // --- GÜVENLİ BLOK BAŞLANGICI ---
                    // İşlemler bitene kadar buradayız.
                    
                    lastClickedPatternId = div.id;

                    // 1. Buton Görünürlüğünü Ayarla
                    if(window.hawkUI && typeof window.hawkUI.updateButtonVisibility === 'function') {
                        window.hawkUI.updateButtonVisibility(pattern.Title);
                    }

                    // 2. Data Saklama
                    window.currentPatternFeatures = pattern.Features;

                    console.group(`🎨 Desen Değişiyor: ${pattern.Title} (Logolar Korunuyor)`);

                    // 3. Clean Linkleri Ayarla
                    const colorName = div.id.toLowerCase(); 
                    const modelsMap = {
                        8: "black", 9: "coal", 10: "dark", 11: "dream", 12: "gray", 13: "stone",
                        22: "black", 27: "coal", 29: "gray", 28: "stone", 30: "dark", 31: "aura"
                    };
                    const validColors = ["black", "coal", "dark", "dream", "gray", "stone", "aura"];
                    let safeColor = validColors.includes(colorName) ? colorName : (modelsMap[item.id] || "black");

                    if (item.Category === "Future") {
                        window.belCleanLink = `https://design.hawkchair.com/static/yastiklar/${safeColor}/alt-yastikk.webp`;
                    }
                    else if (item.Category === "Pro") {
                        window.proCleanLink = `https://design.hawkchair.com/static/yastiklar/pro/${safeColor}/alt-yastikk.webp`;
                    }

                    // 4. Renk & ID & Fiyat
                    if (!window.nicknameyuklendi && !window.yastiklogoyuklendi) {
                        window.logorenk = [pattern.TextColor || "#ffffff"];
                        const nickColorEl = document.getElementById("nicknameColor");
                        if(nickColorEl) nickColorEl.value = pattern.TextColor || "#ffffff";
                        if(window.updateOrderJson) window.updateOrderJson(pattern.TextColor || "#ffffff", "Features.Nickname.Color");
                    }

                    window.tasarimismi = [div.id];
                    window.tasarimismiKontrol = [pattern.Title];

                    this.setPrices(item, pattern); 

                    if(window.updateOrderJson) {
                        window.updateOrderJson(parseInt(pattern.PatternID), "Features.PatternID");
                    }

                    // 5. TEXTURE UYGULAMA (EN UZUN SÜREN KISIM)
                    // Buradaki 'await' işlemleri bitene kadar kod aşağıya inmez.
                    if (window.hawk3D && window.hawkMaterials) {
                        const currentMaterials = window.hawk3D.getModelMaterials();
                        const materialMap = window.hawkMaterials.getMaterialMap(item.Category, currentMaterials, item.Title);
                        
                        // Tüm parçaları tek tek işle ve BEKLE
                        for (let feature of pattern.Features) {
                            await window.hawkMaterials.processFeature(
                                item.Category, feature, materialMap, item.id, pattern.PatternID, pattern.Title, item.Title
                            );
                        }
                        
                        // 6. CACHE GÜNCELLE (Arka planda)
                        // Bunu beklemeye gerek yok ama sırayı bozmamak için burada kalabilir
                        // window.hawkMaterials.captureInitialState() kullanmıyoruz, manuel yönetiyoruz.
                    }
                    if (window.hawkMaterials && typeof window.hawkMaterials.forceFixScales === 'function') {
                        // console.log("🏁 Tüm işlemler bitti, Scale Fix uygulanıyor...");
                        window.hawkMaterials.forceFixScales(2);
                      
                    }
                    if(typeof checksiparis === 'function') checksiparis();
                    
                    console.groupEnd();

                } catch (error) {
                    console.error("⚠️ Desen yüklenirken hata oluştu:", error);
                    // Hata olsa bile finally bloğu çalışıp kilidi açacak.
                } finally {
                    // --- KİLİDİ KALDIR (İŞLEM BİTTİĞİNDE) ---
                    // setTimeout kullanmıyoruz! İşlem ne zaman biterse o zaman açılır.
                    // Sadece geçişin yumuşak olması için minik bir gecikme (50ms) verilebilir.
                    
                    setTimeout(() => {
                        if(clickBlocker) {
                            clickBlocker.style.display = 'none';
                            clickBlocker.classList.remove('active');
                        }
                        if(midLoader) {
                            midLoader.style.display = 'none';
                            midLoader.classList.remove('active');
                        }
                        if (guard) guard.style.display = 'none';
                    }, 100); 
                }
            });
            
            container.appendChild(div);
        });

        // İlk Tıklama
        if (targetToClick) {
            // Eğer "Orijinal" veya "Siyah" gibi özel bir hedef bulunduysa ona tıkla
            setTimeout(() => targetToClick.click(), 100);
        } else {
            // Eğer özel hedef yoksa, LİSTENİN İLK DESENİNE tıkla (Garanti olsun)
            const firstPatternDiv = container.querySelector('.pattern-content');
            if (firstPatternDiv) {
                setTimeout(() => firstPatternDiv.click(), 100);
            }
        }
    }
    // -------------------------------------------------------
    // FİYAT MOTORU (VERİ TABANLI - %100 GÜVENLİ)
    // -------------------------------------------------------
    setPrices(item, pattern) {
        window.orjfiyatlar = [
            { title: 'koltuk', description: item.Price }, 
            { title: 'arka', description: pattern.BackPrice }, 
            { title: 'ön', description: pattern.FrontPrice }, 
            { title: 'desen', description: pattern.SidePrice }, 
            { title: 'bel', description: pattern.WaistPrice }, 
            { title: 'nick', description: 0 }, 
            { title: 'üstyastık', description: 0 }, 
            { title: 'koltukyastıklogo', description: 0 }, 
            { title: 'mousepad', description: item.Price }, 
            { title: 'tshirt', description: item.Price }
        ];
        
        // Standart Fiyatları UI'a bas (Görsel güncelleme)
        if(typeof guncelleFiyat === 'function') {
            ['koltuk', 'ön', 'arka', 'bel', 'desen', 'nick'].forEach(type => guncelleFiyat(type));
        }
        
        // Custom Fiyatları Geri Yükle (Eğer seçiliyse)
        if (window.nicknameyuklendi) this.updateCustomPriceUI("Nickname");
        if (window.yastiklogoyuklendi) this.updateCustomPriceUI("Üst Yastık Logo");
        if (window.onlogoyuklendi) this.updateCustomPriceUI("Ön Logo");
        if (window.arkalogoyuklendi) this.updateCustomPriceUI("Arka Logo");
        if (window.bellogoyuklendi) this.updateCustomPriceUI("Bel Logo");

        // Toplamı Hesapla
        this.updateTotalPrice();
    }

    // --- ÖNEMLİ: BU FONKSİYON ARTIK EKRANA BAKMAZ, VERİYE BAKAR ---
    updateTotalPrice() {
        let total = 0;

        // Helper: Değer ayıklayıcı
        const getVal = (arr, title) => {
            if(!arr) return 0;
            // Küçük/büyük harf duyarlılığı olmasın
            const item = arr.find(x => (x.title && x.title.toLowerCase() === title.toLowerCase()) || (x.Title && x.Title === title));
            if(!item) return 0;
            const rawVal = item.description || item.Description || "0";
            return parseFloat(String(rawVal).replace('₺', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
        };

        // 1. Standart Fiyatlar (Her zaman eklenir)
        total += getVal(window.orjfiyatlar, 'koltuk');
        total += getVal(window.orjfiyatlar, 'desen');

        // 2. Opsiyonel Fiyatlar (Flag'e göre)
        // Eğer Custom (Logo/Nick) varsa Custom Fiyatı, yoksa Standart (Desen) Fiyatı eklenir.
        
        const parts = [
            { flag: window.onlogoyuklendi, stdKey: 'ön', custKey: 'Ön Logo' },
            { flag: window.arkalogoyuklendi, stdKey: 'arka', custKey: 'Arka Logo' },
            { flag: window.bellogoyuklendi, stdKey: 'bel', custKey: 'Bel Logo' },
            { flag: window.yastiklogoyuklendi, stdKey: 'üstyastık', custKey: 'Üst Yastık Logo' },
            { flag: window.nicknameyuklendi, stdKey: 'nick', custKey: 'Nickname' }
        ];

        parts.forEach(part => {
            if (part.flag) {
                // Özel işlem yapılmış, Custom Fiyat ekle
                total += getVal(window.customfiyatlar, part.custKey);
            } else {
                // İşlem yok, desenden gelen standart fiyatı ekle (Genelde 0'dır ama bazı desenlerde değişebilir)
                total += getVal(window.orjfiyatlar, part.stdKey);
            }
        });

        // 3. Ekrana Yazdır
        const formatted = total.toLocaleString('tr-TR') + ' ₺';
        
        const mainPrice = document.getElementById('toplamfiyatsayı');
        if(mainPrice) mainPrice.innerText = formatted;
        
        const mobPrice = document.getElementById('toplamfiyatsayı2');
        if(mobPrice) mobPrice.innerText = formatted;

        // 4. Backend Datasını Güncelle
        if (window.updateOrderJson) window.updateOrderJson(total.toFixed(0), "PaymentAmount");
        
    }
    // HawkProductLogic.js -> updatePriceUI (AKILLI KUTU FİYATI)

    // -------------------------------------------------------
    // AKILLI KUTU FİYATI (YASAKLI ALAN KONTROLLÜ)
    // -------------------------------------------------------
    // -------------------------------------------------------
    // AKILLI KUTU FİYATI (YASAKLI ALAN & ETİKET KONTROLLÜ)
    // -------------------------------------------------------
    updatePriceUI(yer) {
        if(!window.orjfiyatlar) return;

        // 1. YASAKLI ALAN KONTROLÜ
        const currentPattern = (window.tasarimismiKontrol && window.tasarimismiKontrol[0]) ? window.tasarimismiKontrol[0] : "";
        const supportedList = window.desteklenenDesenler || {};
        const hiddenList = (window.desteklenenDesenler && currentPattern) ? window.desteklenenDesenler[currentPattern] : [];
        
        let checkKey = yer.toLowerCase();
        if (checkKey === 'arka logo') checkKey = 'arka';
        if (checkKey === 'ön logo') checkKey = 'ön';
        if (checkKey === 'bel logo') checkKey = 'bel';
        if (checkKey === 'üst yastık logo' || checkKey === 'nickname') checkKey = 'yastık'; 

        if (hiddenList && (hiddenList.includes(checkKey) || hiddenList.includes(yer))) {
            let hideId = '';
            switch(yer) {
                case 'koltuk': hideId = 'koltukfiyati'; break;
                case 'ön': case 'Ön Logo': hideId = 'onfiyati'; break;
                case 'arka': case 'Arka Logo': hideId = 'arkafiyati'; break;
                case 'bel': case 'Bel Logo': hideId = 'belfiyati'; break;
                case 'desen': hideId = 'desenfiyati'; break;
                case 'nick': case 'Nickname': case 'üstyastık': case 'Yastık Logo': hideId = 'isimfiyati'; break;
            }
            
            const container = document.getElementById(hideId);
            if(container) {
                const removeBtn = container.querySelector('.remove-button');
                if(removeBtn) removeBtn.style.display = 'none';

                container.classList.remove('black');
                container.classList.add('active');

                let defaultPrice = 0;
                const defItem = window.orjfiyatlar.find(i => i.title.toLowerCase() === yer.toLowerCase());
                if (defItem) {
                    defaultPrice = parseFloat(String(defItem.description).replace('₺', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
                }
                const span = container.querySelector('span');
                if(span) span.innerText = defaultPrice + ' ₺';

                container.style.display = 'flex';
            }
            return; 
        }

        // 2. Fiyat Hesaplama
        let priceToDisplay = 0;
        const item = window.orjfiyatlar.find(i => i.title.toLowerCase() === yer.toLowerCase());
        if (item) {
            priceToDisplay = parseFloat(String(item.description).replace('₺', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
        }

        const getCustomVal = (title) => {
            if(!window.customfiyatlar) return 0;
            const cItem = window.customfiyatlar.find(x => x.Title === title);
            if(!cItem) return 0;
            return parseFloat(String(cItem.Description).replace('₺', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
        };

        let isActiveCustom = false;

        switch(yer) {
            case 'ön': case 'Ön Logo': if (window.onlogoyuklendi) { priceToDisplay = getCustomVal("Ön Logo"); isActiveCustom = true; } break;
            case 'arka': case 'Arka Logo': if (window.arkalogoyuklendi) { priceToDisplay = getCustomVal("Arka Logo"); isActiveCustom = true; } break;
            case 'bel': case 'Bel Logo': if (window.bellogoyuklendi) { priceToDisplay = getCustomVal("Bel Logo"); isActiveCustom = true; } break;
            case 'nick': case 'Nickname': case 'üstyastık': case 'Yastık Logo':
                if (window.yastiklogoyuklendi) { priceToDisplay = getCustomVal("Üst Yastık Logo"); isActiveCustom = true; }
                else if (window.nicknameyuklendi) { priceToDisplay = getCustomVal("Nickname"); isActiveCustom = true; }
                break;
        }

        // 3. DOM'a Yaz
        let domId = '';
        switch(yer) {
            case 'koltuk': domId = 'koltukfiyati'; break;
            case 'ön': case 'Ön Logo': domId = 'onfiyati'; break;
            case 'arka': case 'Arka Logo': domId = 'arkafiyati'; break;
            case 'bel': case 'Bel Logo': domId = 'belfiyati'; break;
            case 'desen': domId = 'desenfiyati'; break;
            case 'nick': case 'Nickname': case 'üstyastık': case 'Yastık Logo': domId = 'isimfiyati'; break;
        }

        if(domId) {
            const container = document.getElementById(domId);
            if(container) {
                const span = container.querySelector('span');
                if(span) span.innerText = priceToDisplay + ' ₺';
                
                if (isActiveCustom) {
                    container.classList.add('black'); container.classList.remove('active');
                } else {
                    container.classList.add('active'); container.classList.remove('black');
                }
                
                // --- KRİTİK EKLEME: ETİKET İSMİNİ DEĞİŞTİR ---
                if (yer === 'koltuk') {
                    const labelP = document.getElementById('trkoltukfiyati');
                    if (labelP) {
                        // Mevcut kategoriyi kontrol et
                        const activeCat = (window.cinsbutton && window.cinsbutton[0]) ? window.cinsbutton[0].toLowerCase() : "future";
                        
                        if (activeCat === 'aksesuar') {
                            labelP.innerText = "Yastık Fiyatı :";
                        } else {
                            labelP.innerText = "Koltuk Fiyatı :";
                        }
                    }
                }
                // ---------------------------------------------

                container.style.display = 'flex'; 
            }
        }
    }
    updateCustomPriceUI(yer) {
        if(!window.customfiyatlar) return;
        var fiyat = window.customfiyatlar.find(item => item.Title === yer)?.Description;
        let domId = '', label = '';
        switch(yer) {
            case 'Ön Logo': domId = 'onfiyati'; break;
            case 'Arka Logo': domId = 'arkafiyati'; break;
            case 'Bel Logo': domId = 'belfiyati'; break;
            case 'Nickname': domId = 'isimfiyati'; label = "İsim Yazdırma :"; break;
            case 'Üst Yastık Logo': domId = 'isimfiyati'; label = "Yastık Logo :"; break;
        }
        if(domId) {
            const container = document.getElementById(domId);
            if(container) {
                const p = container.querySelector('p');
                const span = container.querySelector('span');
                if(p && label) p.innerText = label;
                if(span) span.innerText = fiyat + ' ₺';
                container.classList.remove('active');
                container.classList.add('black');
                container.style.display = 'flex';
            }
        }
    }

    handleInitialLoad() {
        const defaultBtn = document.getElementById('futureklasor');
        if(defaultBtn) {
            defaultBtn.classList.add('active');
            this.switchCategory('future', 'https://design.hawkchair.com/static/models/futureOrj2.glb', '8');
        }
        setTimeout(() => {
            const loadingScreen = document.getElementById("loadingson");
            if (loadingScreen) { 
                loadingScreen.style.opacity = "0"; 
                setTimeout(() => { loadingScreen.style.display = "none"; }, 500); 
            }
        }, 1500);
    }
}

// Global Bridge
window.hawkProduct = new HawkProductLogic();
window.createModel = function(approved) { window.hawkProduct.init(approved); };
window.guncelleFiyat = (yer) => window.hawkProduct.updatePriceUI(yer);
window.guncelleCustomFiyat = (yer) => window.hawkProduct.updateCustomPriceUI(yer);
window.updateTotalPrice = () => window.hawkProduct.updateTotalPrice();